import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import bg from "../../../assets/Chat/image.png";
import CommonTable from "../../Table/CommonTable";
import { API_END_POINT, TOKEN } from "../../../constant";
import axios from "axios";
import { toast } from "react-toastify";
import Loader from "../../Loader/Loader";
import { Client } from "@stomp/stompjs";
import SockJS from "sockjs-client";

function Chat() {
  const stompClient = useRef(null);
  const rawName = localStorage.getItem("mainUserName");
  const userName = JSON.parse(rawName);
  const [content, setContent] = useState("");
  const [chat, setChat] = useState([]);
  const [astrologerCallId, setAstrologerCallId] = useState(null);
  const [ischat, setIsChat] = useState(false);
  const [chatList, setChatList] = useState("");
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [username, setUsername] = useState("");
  const chatBoxRef = useRef(null);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [userId, setUserId] = useState(null);
  const [timer, setTimer] = useState();
  const [loading, setLoading] = useState(false);
  const [isOnline, setIsOnline] = useState({});
  const [flag, setFlag] = useState(false);
  const { id } = useParams();

  const astrologerId = id;
  const astro_id = localStorage.getItem("astro_id");

  const calculateModalSize = () => {
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;

    let modalWidth = Math.min(screenWidth * 0.8, 500);
    let modalHeight = Math.min(screenHeight * 0.8, 600);

    return { width: modalWidth, height: modalHeight };
  };

  const modalSize = calculateModalSize();

  useEffect(() => {
    // fetchMessages();

    const handleChatClick = async (id) => {
      if (!astrologerId) {
        console.error("astrologerId is missing!");
        return;
      }
      // setLoading(true)
      const getChatListUrl = `${API_END_POINT}astrologers/all-requested-chats?astrologerId=${id}`;
      const getChatListHeaders = {
        Authorization: `Bearer ${TOKEN}`
      };
      try {
        const response = await fetch(getChatListUrl, {
          method: "GET",
          headers: getChatListHeaders
        });
        if (!response.ok) {
          toast.error("failed to fetch chat list");
        }
        const responseData = await response.json();
        setChatList(responseData.data);
      } catch (error) {
        console.log("error in handle chat click (interval) ---->>>>", error);
      } finally {
        // setLoading(false)
      }
    };

    // Initial call
    handleChatClick(astrologerId);

    // Set up the interval to call handleChatClick with the current astrologerId
    if (!isChatOpen) {
      const intervalId = setInterval(() => {
        handleChatClick(astrologerId);
      }, 15000);

      return () => {
        clearInterval(intervalId);
      };
    }
  }, [astrologerId]);

  // useEffect(() => {
  //     fetchMessages();
  //     // handleChatClick(astrologerId);
  //     const handleChatClick = async (astrologerId) => {
  //         setIsChat(prevState => !prevState)
  //         const getChatListUrl = `${API_END_POINT}astrologers/get-all-chats-userdata/${astrologerId}`
  //         const getChatListHeaders = {
  //             Authorization: `Bearer ${TOKEN}`
  //         }
  //         try {

  //             const response = await fetch(getChatListUrl, { method: 'GET', headers: getChatListHeaders })

  //             if (!response.ok) {
  //                 toast.error('failed to fetch chat list')
  //             }

  //             const responseData = await response.json()

  //             setChatList(responseData.data)
  //             console.log("the data chatlist", responseData.data)

  //         } catch (error) {
  //             console.log("error in handle chat click () ---->>>>")
  //         }

  //     }

  //     handleChatClick(astrologerId);

  //     const intervalId = setInterval(handleChatClick(astrologerId), 15000);

  //     return () => {
  //         clearInterval(intervalId);
  //       };

  // }, [astrologerId])

  // setTimeout(()=>{
  //     if(!isChatOpen){
  //         handleChatClick(astrologerId);
  //     }
  // },15000)

  useEffect(() => {
    if (chatBoxRef.current) {
      chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight;
    }
  }, [chat]);

  // const handleChatClick2 = async (astrologerId) => {
  //     setIsChat(prevState => !prevState)
  //     const getChatListUrl = `${API_END_POINT}astrologers/get-all-chats-userdata/${astrologerId}`
  //     const getChatListHeaders = {
  //         Authorization: `Bearer ${TOKEN}`
  //     }
  //     try {

  //         const response = await fetch(getChatListUrl, { method: 'GET', headers: getChatListHeaders })

  //         if (!response.ok) {
  //             toast.error('failed to fetch chat list')
  //         }

  //         const responseData = await response.json()

  //         setChatList(responseData.data)
  //         console.log("the data chatlist", responseData.data)

  //     } catch (error) {
  //         console.log("error in handle chat click () ---->>>>")
  //     }

  // }

  const handleChatClick = async (astrologerId) => {
    setIsChat((prevState) => !prevState);
    const getChatListUrl = `${API_END_POINT}astrologers/get-all-chats-userdata/${astrologerId}`;
    const getChatListHeaders = {
      Authorization: `Bearer ${TOKEN}`
    };
    try {
      const response = await fetch(getChatListUrl, {
        method: "GET",
        headers: getChatListHeaders
      });

      if (!response.ok) {
        toast.error("failed to fetch chat list");
      }

      const responseData = await response.json();

      setChatList(responseData.data);
      console.log("the data chatlist", responseData.data);
    } catch (error) {
      console.log("error in handle chat click () ---->>>>");
    }
  };

  const handleSendMessage = async () => {
    await sendMessage();
    fetchMessages();
  };

  //   useEffect(() => {
  //     if (isChatOpen) {
  //       fetchMessages();
  //       const interval = setInterval(fetchMessages, 1000);
  //       return () => clearInterval(interval);
  //     }
  //   }, [isChatOpen]);

  useEffect(() => {
    if (isChatOpen && timer > 0 && flag == true) {
      const countdown = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);

      return () => clearInterval(countdown);
    } else if (timer === 0) {
      setIsChatOpen(false);
    }
  }, [isChatOpen, timer, flag]);

  const sendMessage = async () => {
    if (!input.trim()) return;
    try {
      const response = await axios.post(
        `${API_END_POINT}astrologers/save-chat-astrologer`,
        {
          userId,
          astrologerId,
          message: input,
          isMessageSentByUser: false
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${TOKEN}`
          }
        }
      );
      setInput("");
      if (response.status === 200) {
        console.log("success");
      } else {
        console.error("Error sending message:", response.data);
      }
    } catch (error) {
      console.error("Network error:", error);
    }
  };

  const fetchMessages = async () => {
    try {
      const response = await axios.get(
        `${API_END_POINT}astrologers/get-chats-user/${astrologerId}/${userId}`,
        {
          headers: {
            Authorization: `Bearer ${TOKEN}`
          }
        }
      );

      if (response.status === 200) {
        const data = response.data.data;
        const chatStatus = response.data.data[0].isChatCompleted;
        if (chatStatus) {
          setIsChatOpen(false);
        }
        setMessages(data.reverse() || []);
      } else {
        console.error("Failed to fetch messages");
      }
    } catch (error) {
      console.error("Error fetching messages:", error);
    }
  };

  const handleStatusChange = async (id) => {
    setLoading(true)

    const updateStatusUrl = `${API_END_POINT}astrologers/approved-chat?chatId=${id}`
    const updateStatusHeader = {
      Authorization: `Bearer ${TOKEN}`
    }
    try {

      const response = await fetch(updateStatusUrl, { method: 'PUT', headers: updateStatusHeader })

      if (!response.ok) {
        toast.error("failed to update status")
        return
      }
      toast.success("status changed successfully")
      const responseData = response.json();
      // getAstrologer()

    } catch (error) {
      console.log("handle status change --->>>", error)

    } finally {
      setLoading(false)
    }
  };

  const chatListColumn = [
    {
      name: "Sr. No.",
      cell: (row, index) => row.chatId
    },
    {
      name: "User Name",
      cell: (row) => row?.username
    },
    {
      name: "Actions",
      cell: (row, index) => (
        <div className="flex align-center gap-10">
          <button
            className="edit-btn"
            onClick={() => {
              if(row.isChatApproved) {
                setTimer(row.chatTime*60);
                setUserId(row.userId);
                setIsChatOpen(true);
                setUsername(row.username);
              } else if (row.isChatCompleted != null) {
                toast.warning("Chat is already completed")
              } else {
                toast.warning("Approve a request to open this chat")
              }
              // connect();
            }}
          >
            <svg
              width="24"
              height="24"
              fill="none"
              stroke="#AE285D"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.862 9.862 0 0 1-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8Z"></path>
            </svg>
          </button>
        </div>
      )
    },
    {
      name: "Status",
      cell: (row) => (
        <div>
          {row.isChatCompleted ? (
            <span style={{ color: "green" }}>completed</span>
          ) : (
            <span style={{ color: "red" }}>In Progress....</span>
          )}
        </div>
      )
    },
    {
      name: "Approve Status",
      cell: (row, index) => {
        isOnline[row?.chatId] = row?.isChatApproved;
        return (
          <div className="button r" id="button-1">
            <input type="checkbox" className="checkbox" checked={isOnline[row?.chatId]} onChange={(e) => (row.isChatApproved == false && handleStatusChange(row?.chatId))}/>
            <div className="knobs"></div>
            <div className="layer"></div>
          </div>
        )
      }
    },
    {
      name: "Chat Time",
      cell: (row) => row?.chatTime
    },
    {
      name: "Last Message",
      cell: (row) => row?.timeStamp
    }
  ];

  // websocket start
  const getCurrentTime = () => {
    const now = new Date();
    return now.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true
    });
  };

  const logToChat = (text, css = "priv") => {
    const timestamp = getCurrentTime();
    setChat((prev) => [...prev, { text, css, time: timestamp }]);
  };

  const must = (value, label) => {
    if (!value) throw new Error(`Please enter ${label}.`);
  };

  const connect = () => {
    try {
      must(TOKEN, "JWT token");
      must(+astro_id, "your ID");
      //   must(userName, "your name");

      const socket = new SockJS(
        "https://kundalip.springdev.in/ws?token=" + encodeURIComponent(TOKEN)
      );

      stompClient.current = new Client({
        webSocketFactory: () => socket,
        debug: () => {},
        onConnect: () => {
          //   sendMessageNew();
          stompClient.current.subscribe("/user/queue/history", (message) => {
            const history = JSON.parse(message.body);
            history.forEach((m) => logToChat(`[history] ${m.content}`, "hist"));
          });

          stompClient.current.subscribe(
            "/topic/messages/" + astro_id,
            (message) => {
              const m = JSON.parse(message.body);
              logToChat(`${m.content}`, "priv");
            }
          );
        },
        onStompError: (frame) => {
          console.error("STOMP error:", frame.headers["message"], frame.body);
          alert("STOMP connection error – see console");
        },
        onWebSocketError: (error) => {
          console.error("WebSocket error:", error);
          alert("WebSocket error – see console");
        }
      });

      stompClient.current.activate();
    } catch (e) {
      alert(e.message);
    }
  };

  const sendMessageNew = (id) => {
    try {
      // must(stompClient.current && stompClient.current.connected, 'a WebSocket connection');
      must(userId, "recipient ID");
      must(content.trim(), "message");

      const payload = {
        senderId: +astro_id,
        recipientId: +userId,
        content: content
      };

      stompClient.current.publish({
        destination: "/app/send-private1",
        body: JSON.stringify(payload)
      });
      logToChat(`pandit ${content}`);
      setContent("");
    } catch (e) {
      alert(e.message);
    }
  };

  useEffect(() => {
    connect();
  }, []);
  // websocket end

  return (
    <main className="main">
      <h3>Astrologer Chat</h3>
      <div>
        {/* {loading ? (
                    <>
                        <Loader />
                    </>
                ) : (
                    <>
                        <div style={{ marginTop: "10px" }} onClick={(e) => { console.log("object", e.target) }} >
                            <CommonTable columns={chatListColumn} data={chatList} />
                        </div>  
                    </>
                )} */}
        <div
          style={{ marginTop: "10px" }}
          onClick={(e) => {
            console.log("object", e.target);
          }}
        >
          <CommonTable columns={chatListColumn} data={chatList} />
        </div>
        <div className="container">
          {isChatOpen && (
            <>
              {/* <div
                                  className="modal-overlay"
                                  style={{
                                    position: "fixed",
                                    top: 0,
                                    left: 0,
                                    width: "100%",
                                    height: "100%",
                                    backgroundColor: "rgba(0, 0, 0, 0.05)",
                                    zIndex: 1040,
                                  }}
                                ></div> */}

              <div
                className="modal-overlay"
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(0, 0, 0, 0.05)",
                  zIndex: 1040,
                  display: isChatOpen ? "block" : "none"
                }}
                // onClick={() => setIsChatOpen(false)}
              >
                <div
                  className="modal"
                  style={{
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    display: "block",
                    zIndex: 1050,
                    width: modalSize.width,
                    height: modalSize.height
                  }}
                  // onClick={(e) => e.stopPropagation()}
                >
                  <div className="modal-dialog" style={{ height: "100%" }}>
                    <div
                      className="modal-content"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        height: "100%"
                      }}
                    >
                      <div
                        className="modal-header"
                        style={{
                          backgroundColor: "#f8f9fa",
                          display: "flex",
                          alignItems: "center", // Vertically align items
                          justifyContent: "space-between" // Distribute space between items
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            padding: "5px"
                          }}
                        >
                          {" "}
                          {/* Container for left side */}
                          <img
                            src="https://cdn-icons-png.flaticon.com/512/149/149071.png"
                            alt="Astrologer"
                            width="30"
                            style={{ marginRight: "0.5rem" }}
                          />
                          <h5 className="modal-title" style={{ margin: 0 }}>
                            {" "}
                            {/* Remove default margin */}
                            chat with {username}
                          </h5>
                        </div>
                        <button
                          type="button"
                          className="btn-close"
                          style={{
                            boxShadow: "none",
                            border: "none",
                            marginRight: "10px",
                            background: "transparent"
                            // padding : '10px'
                            // Add any other styles for the close button here
                          }}
                          onClick={() => {
                            console.log("message chat", messages);
                            setIsChatOpen(false);
                          }}
                        >
                          <svg
                            width="26"
                            height="26"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {" "}
                            <path
                              fill-rule="evenodd"
                              d="M5.152 5.152a1.2 1.2 0 0 1 1.696 0L12 10.303l5.152-5.151a1.2 1.2 0 1 1 1.696 1.696L13.697 12l5.151 5.152a1.2 1.2 0 0 1-1.696 1.696L12 13.697l-5.152 5.151a1.2 1.2 0 0 1-1.696-1.696L10.303 12 5.152 6.848a1.2 1.2 0 0 1 0-1.696Z"
                              clip-rule="evenodd"
                            ></path>{" "}
                          </svg>
                        </button>
                      </div>

                      <div
                        className="modal-body chat-box"
                        ref={chatBoxRef}
                        style={{
                          flex: 1,
                          height: "350px",
                          overflowY: "auto",
                          backgroundImage: `url(${bg})`,
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          padding: "10px",
                          borderRadius: "5px"
                        }}
                      >
                        {chat.map((msg) => {
                          const processedText = msg.text.startsWith("pandit")
                            ? msg.text.replace(/^pandit\s+/i, "")
                            : msg.text.replace(/^you\s+/i, "");
                          return msg.text.startsWith("pandit") ? (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-end",
                                marginBottom: "10px"
                              }}
                            >
                              <div
                                className="rounded text-dark"
                                style={{
                                  textAlign: "left",
                                  maxWidth: "65%",
                                  background: "#d8fdd1",
                                  padding: "10px",
                                  borderRadius: "7px",
                                  borderTopLeftRadius: "0px"
                                }}
                              >
                                <pre
                                  style={{
                                    margin: 0,
                                    whiteSpace: "pre-wrap",
                                    wordBreak: "break-word",
                                    overflowWrap: "break-word",
                                    fontFamily: "Poppins",
                                    wordSpacing: "2px",
                                    letterSpacing: "1px"
                                  }}
                                >
                                  {processedText}
                                </pre>
                              </div>
                              <small
                                className="text-muted mt-1"
                                style={{
                                  fontSize: "10px",
                                  fontFamily: "Poppins",
                                  marginTop: "4px"
                                }}
                              >
                                {msg.time}
                              </small>
                            </div>
                          ) : (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                                marginBottom: "15px"
                              }}
                            >
                              <div
                                className="p-3 rounded"
                                style={{
                                  maxWidth: "65%",
                                  width: "auto",
                                  background: "rgba(255, 255, 255, 0.8)",
                                  textAlign: "left",
                                  padding: "10px",
                                  borderRadius: "7px",
                                  borderTopRightRadius: "0px"
                                }}
                              >
                                <pre
                                  style={{
                                    margin: 0,
                                    whiteSpace: "pre-wrap",
                                    wordBreak: "break-word",
                                    overflowWrap: "break-word",
                                    fontFamily: "Poppins",
                                    wordSpacing: "2px",
                                    letterSpacing: "1px"
                                  }}
                                >
                                  {processedText}
                                </pre>
                              </div>
                              <small
                                className="text-muted mt-1"
                                style={{
                                  fontSize: "10px",
                                  fontFamily: "Poppins",
                                  marginTop: "4px"
                                }}
                              >
                                {msg.time}
                              </small>
                            </div>
                          );
                        })}
                      </div>

                      <div
                        className="chat-input"
                        style={{
                          padding: "1rem 0.5rem",
                          backgroundColor: "#fff",
                          display: "flex",
                          alignItems: "center",
                          flexWrap: "wrap"
                        }}
                      >
                        <input
                          type="text"
                          className="form-control"
                          style={{
                            marginRight: "1rem",
                            borderRadius: "2.5rem",
                            padding: "0.5rem 1rem",
                            width: "100%"
                          }}
                          placeholder="Type your message here..."
                          value={content}
                          onChange={(e) => setContent(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              // handleSendMessage();
                              if(content != "") {
                              if(flag == false) {
                                setFlag(true);
                              }
                              sendMessageNew();
                            }
                            }
                          }}
                        />
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            width: "100%"
                          }}
                        >
                          <button
                            onClick={() => {
                              // handleSendMessage();
                              if(content != "") {
                              if(flag == false) {
                                setFlag(true);
                              }
                              sendMessageNew();
                            }
                            }}
                            style={{
                              fontSize: "12px",
                              backgroundColor: "#ff6f00",
                              color: "#fff",
                              padding: "0.5rem 1rem",
                              border: "none",
                              borderRadius: "5px",
                              marginTop: "15px",
                              justifyContent: "center"
                            }}
                          >
                            Send
                          </button>
                        </div>
                      </div>

                      <div
                        className="call-info"
                        style={{
                          padding: "0.5rem",
                          backgroundColor: "#28a745",
                          color: "#fff",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "0.5rem"
                        }}
                      >
                        <span style={{ textAlign: "center" }}>
                          Remaining Time: {Math.floor(timer / 60)}:
                          {String(timer % 60).padStart(2, "0")}
                        </span>
                        {/* <button
                          className="end-call"
                          style={{
                            padding: "0.5rem 1rem",
                            border: "none",
                            borderRadius: "5px"
                          }}
                          onClick={() => {
                          }}
                        >
                          End Call
                        </button> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </main>
  );
}

export default Chat;

// import React, { useEffect, useRef, useState } from 'react'
// import { useParams } from 'react-router-dom';
// import bg from '../../../assets/Chat/image.png'
// import CommonTable from '../../Table/CommonTable';
// import { API_END_POINT, TOKEN } from '../../../constant';
// import axios from 'axios';
// import { toast } from 'react-toastify';
// import Loader from '../../Loader/Loader';

// function Chat() {
//     const [ischat, setIsChat] = useState(false)
//     const [chatList, setChatList] = useState('')
//     const [isChatOpen, setIsChatOpen] = useState(false);
//     const [username, setUsername] = useState('')
//     const chatBoxRef = useRef(null);
//     const [messages, setMessages] = useState([]);
//     const [input, setInput] = useState("");
//     const [userId, setUserId] = useState(null)
//     const [timer, setTimer] = useState(240);
//     const [loading, setLoading] = useState(false);

//     const { id } = useParams();

//     const astrologerId = id;

//     const calculateModalSize = () => {
//         const screenWidth = window.innerWidth;
//         const screenHeight = window.innerHeight;

//         let modalWidth = Math.min(screenWidth * 0.8, 500);
//         let modalHeight = Math.min(screenHeight * 0.8, 600);

//         return { width: modalWidth, height: modalHeight };
//     };

//     const modalSize = calculateModalSize();

//     useEffect(() => {
//         fetchMessages();

//         const handleChatClick = async (id) => {
//             if (!astrologerId) {
//                 console.error('astrologerId is missing!');
//                 return;
//             }
//             // setLoading(true)
//             const getChatListUrl = `${API_END_POINT}astrologers/get-all-chats-userdata/${id}`;
//             const getChatListHeaders = {
//                 Authorization: `Bearer ${TOKEN}`
//             };
//             try {
//                 const response = await fetch(getChatListUrl, { method: 'GET', headers: getChatListHeaders });
//                 if (!response.ok) {
//                     toast.error('failed to fetch chat list');
//                 }
//                 const responseData = await response.json();
//                 setChatList(responseData.data);
//                 console.log("the data chatlist (interval)", responseData.data);
//             } catch (error) {
//                 console.log("error in handle chat click (interval) ---->>>>", error);
//             } finally {
//                 // setLoading(false)
//             }
//         };

//         // Initial call
//         handleChatClick(astrologerId);

//         // Set up the interval to call handleChatClick with the current astrologerId
//         if (!isChatOpen) {
//             const intervalId = setInterval(() => {
//                 handleChatClick(astrologerId);
//             }, 15000);

//             return () => {
//                 clearInterval(intervalId);
//             };
//         }

//     }, [astrologerId]);

//     // useEffect(() => {
//     //     fetchMessages();
//     //     // handleChatClick(astrologerId);
//     //     const handleChatClick = async (astrologerId) => {
//     //         setIsChat(prevState => !prevState)
//     //         const getChatListUrl = `${API_END_POINT}astrologers/get-all-chats-userdata/${astrologerId}`
//     //         const getChatListHeaders = {
//     //             Authorization: `Bearer ${TOKEN}`
//     //         }
//     //         try {

//     //             const response = await fetch(getChatListUrl, { method: 'GET', headers: getChatListHeaders })

//     //             if (!response.ok) {
//     //                 toast.error('failed to fetch chat list')
//     //             }

//     //             const responseData = await response.json()

//     //             setChatList(responseData.data)
//     //             console.log("the data chatlist", responseData.data)

//     //         } catch (error) {
//     //             console.log("error in handle chat click () ---->>>>")
//     //         }

//     //     }

//     //     handleChatClick(astrologerId);

//     //     const intervalId = setInterval(handleChatClick(astrologerId), 15000);

//     //     return () => {
//     //         clearInterval(intervalId);
//     //       };

//     // }, [astrologerId])

//     // setTimeout(()=>{
//     //     if(!isChatOpen){
//     //         handleChatClick(astrologerId);
//     //     }
//     // },15000)

//     useEffect(() => {
//         if (chatBoxRef.current) {
//             chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight;
//         }
//     }, [messages]);

//     // const handleChatClick2 = async (astrologerId) => {
//     //     setIsChat(prevState => !prevState)
//     //     const getChatListUrl = `${API_END_POINT}astrologers/get-all-chats-userdata/${astrologerId}`
//     //     const getChatListHeaders = {
//     //         Authorization: `Bearer ${TOKEN}`
//     //     }
//     //     try {

//     //         const response = await fetch(getChatListUrl, { method: 'GET', headers: getChatListHeaders })

//     //         if (!response.ok) {
//     //             toast.error('failed to fetch chat list')
//     //         }

//     //         const responseData = await response.json()

//     //         setChatList(responseData.data)
//     //         console.log("the data chatlist", responseData.data)

//     //     } catch (error) {
//     //         console.log("error in handle chat click () ---->>>>")
//     //     }

//     // }

//     const handleChatClick = async (astrologerId) => {
//         setIsChat(prevState => !prevState)
//         const getChatListUrl = `${API_END_POINT}astrologers/get-all-chats-userdata/${astrologerId}`
//         const getChatListHeaders = {
//             Authorization: `Bearer ${TOKEN}`
//         }
//         try {

//             const response = await fetch(getChatListUrl, { method: 'GET', headers: getChatListHeaders })

//             if (!response.ok) {
//                 toast.error('failed to fetch chat list')
//             }

//             const responseData = await response.json()

//             setChatList(responseData.data)
//             console.log("the data chatlist", responseData.data)

//         } catch (error) {
//             console.log("error in handle chat click () ---->>>>")
//         }

//     }

//     const handleSendMessage = async () => {
//         await sendMessage();
//         fetchMessages();
//     };

//     useEffect(() => {
//         if (isChatOpen) {
//             fetchMessages();
//             const interval = setInterval(fetchMessages, 1000);
//             return () => clearInterval(interval);
//         }
//     }, [isChatOpen])

//     useEffect(() => {
//         if (isChatOpen && timer > 0) {
//             const countdown = setInterval(() => {
//                 setTimer((prevTimer) => prevTimer - 1);
//             }, 1000);

//             return () => clearInterval(countdown);
//         } else if (timer === 0) {
//             setIsChatOpen(false);
//         }
//     }, [isChatOpen, timer]);

//     const sendMessage = async () => {
//         if (!input.trim()) return;
//         try {
//             const response = await axios.post(
//                 `${API_END_POINT}astrologers/save-chat-astrologer`,
//                 {
//                     userId,
//                     astrologerId,
//                     message: input,
//                     isMessageSentByUser: false,
//                 },
//                 {
//                     headers: {
//                         "Content-Type": "application/json",
//                         "Authorization": `Bearer ${TOKEN}`,
//                     },
//                 }
//             );
//             setInput("");
//             if (response.status === 200) {
//                 console.log("success");
//             } else {
//                 console.error("Error sending message:", response.data);
//             }
//         } catch (error) {
//             console.error("Network error:", error);
//         }
//     };

//     const fetchMessages = async () => {
//         try {
//             const response = await axios.get(
//                 `${API_END_POINT}astrologers/get-chats-user/${astrologerId}/${userId}`,
//                 {
//                     headers: {
//                         Authorization:
//                             `Bearer ${TOKEN}`,
//                     },
//                 }
//             );

//             if (response.status === 200) {
//                 const data = response.data.data;
//                 console.log("prenting data -> ", data);
//                 const chatStatus = response.data.data[0].isChatCompleted
//                 if (chatStatus) {
//                     setIsChatOpen(false)
//                 }
//                 console.log("chatstatus is this  ===......>>> , ", chatStatus)
//                 setMessages(data.reverse() || []);
//                 console.log("this is set message --- >>>", messages)
//             } else {
//                 console.error("Failed to fetch messages");
//             }
//         } catch (error) {
//             console.error("Error fetching messages:", error);
//         }
//     };

//     const chatListColumn = [
//         {
//             name: 'Sr. No.',
//             cell: (row, index) => row.chatId,
//         },
//         {
//             name: "User Name",
//             cell: (row) => row?.username,
//         },
//         {
//             name: 'Actions',
//             cell: (row, index) => (
//                 <div className='flex align-center gap-10' >
//                     <button className='edit-btn' onClick={() => {
//                         setUserId(row.userId)
//                         setIsChatOpen(true)
//                         setUsername(row.username)
//                     }} >
//                         <svg
//                             width="24"
//                             height="24"
//                             fill="none"
//                             stroke="#AE285D"
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                             strokeWidth="2"
//                             viewBox="0 0 24 24"
//                             xmlns="http://www.w3.org/2000/svg"
//                         >
//                             <path d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.862 9.862 0 0 1-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8Z"></path>
//                         </svg>
//                     </button>
//                 </div>
//             ),
//         },
//         {
//             name: 'Status',
//             cell: (row) => (
//                 <div>
//                     {row.isChatCompleted ? <span style={{ color: 'green' }} >
//                         completed
//                     </span> : <span style={{ color: 'red' }} >
//                         In Progress....
//                     </span>}
//                 </div>
//             ),
//         },
//         {
//             name: "Chat Time",
//             cell: (row) => row?.chatTime
//         },
//         {
//             name: "Last Message",
//             cell: (row) => row?.timeStamp,
//         },

//     ]

//     return (
//         <main className='main'>
//             <h3>Astrologer Chat</h3>
//             <div>
//                 {/* {loading ? (
//                     <>
//                         <Loader />
//                     </>
//                 ) : (
//                     <>
//                         <div style={{ marginTop: "10px" }} onClick={(e) => { console.log("object", e.target) }} >
//                             <CommonTable columns={chatListColumn} data={chatList} />
//                         </div>
//                     </>
//                 )} */}
//                 <div style={{ marginTop: "10px" }} onClick={(e) => { console.log("object", e.target) }} >
//                     <CommonTable columns={chatListColumn} data={chatList} />
//                 </div>
//                 <div className="container">
//                     {isChatOpen && (
//                         <>
//                             {/* <div
//                                   className="modal-overlay"
//                                   style={{
//                                     position: "fixed",
//                                     top: 0,
//                                     left: 0,
//                                     width: "100%",
//                                     height: "100%",
//                                     backgroundColor: "rgba(0, 0, 0, 0.05)",
//                                     zIndex: 1040,
//                                   }}
//                                 ></div> */}

//                             <div
//                                 className="modal-overlay"
//                                 style={{
//                                     position: "fixed",
//                                     top: 0,
//                                     left: 0,
//                                     width: "100%",
//                                     height: "100%",
//                                     backgroundColor: "rgba(0, 0, 0, 0.05)",
//                                     zIndex: 1040,
//                                     display: isChatOpen ? 'block' : 'none'
//                                 }}
//                                 onClick={() => setIsChatOpen(false)}
//                             >
//                                 <div
//                                     className="modal"
//                                     style={{
//                                         position: "fixed",
//                                         top: "50%",
//                                         left: "50%",
//                                         transform: "translate(-50%, -50%)",
//                                         display: "block",
//                                         zIndex: 1050,
//                                         width: modalSize.width,
//                                         height: modalSize.height,
//                                     }}
//                                     onClick={(e) => e.stopPropagation()}
//                                 >
//                                     <div className="modal-dialog" style={{ height: '100%' }}>
//                                         <div className="modal-content" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
//                                             <div
//                                                 className="modal-header"
//                                                 style={{
//                                                     backgroundColor: "#f8f9fa",
//                                                     display: "flex",
//                                                     alignItems: "center", // Vertically align items
//                                                     justifyContent: "space-between", // Distribute space between items
//                                                 }}
//                                             >
//                                                 <div style={{ display: "flex", alignItems: "center", padding: '5px' }}> {/* Container for left side */}
//                                                     <img
//                                                         src="https://cdn-icons-png.flaticon.com/512/149/149071.png"
//                                                         alt="Astrologer"
//                                                         width="30"
//                                                         style={{ marginRight: "0.5rem" }}
//                                                     />
//                                                     <h5 className="modal-title" style={{ margin: 0 }}> {/* Remove default margin */}
//                                                         chat with {username}
//                                                     </h5>
//                                                 </div>
//                                                 <button
//                                                     type="button"
//                                                     className="btn-close"
//                                                     style={{
//                                                         boxShadow: "none",
//                                                         border: "none",
//                                                         marginRight: '10px',
//                                                         background: 'transparent'
//                                                         // padding : '10px'
//                                                         // Add any other styles for the close button here
//                                                     }}
//                                                     onClick={() => {
//                                                         console.log("message chat", messages)
//                                                         setIsChatOpen(false)
//                                                     }}
//                                                 ><svg width="26" height="26" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">   <path fill-rule="evenodd" d="M5.152 5.152a1.2 1.2 0 0 1 1.696 0L12 10.303l5.152-5.151a1.2 1.2 0 1 1 1.696 1.696L13.697 12l5.151 5.152a1.2 1.2 0 0 1-1.696 1.696L12 13.697l-5.152 5.151a1.2 1.2 0 0 1-1.696-1.696L10.303 12 5.152 6.848a1.2 1.2 0 0 1 0-1.696Z" clip-rule="evenodd"></path> </svg>

//                                                 </button>
//                                             </div>

//                                             <div
//                                                 className="modal-body chat-box"
//                                                 ref={chatBoxRef}
//                                                 style={{
//                                                     flex: 1,
//                                                     overflowY: "auto",
//                                                     backgroundImage: `url(${bg})`,
//                                                     backgroundSize: "cover",
//                                                     backgroundPosition: "center",
//                                                     padding: "10px",
//                                                     borderRadius: "5px",
//                                                 }}
//                                             >
//                                                 {messages.map((msg, index) => (
//                                                     <div key={index} style={{ marginBottom: "1rem" }}>
//                                                         {msg.isMessageSentByUser === true ? (
//                                                             <div
//                                                                 className="message-left"
//                                                                 style={{
//                                                                     textAlign: "left",
//                                                                     maxWidth: "70%", // Increased max width
//                                                                     background: "rgba(255, 255, 255, 0.8)",
//                                                                     padding: "0.5rem",
//                                                                     borderRadius: "5px",
//                                                                     color: "#212529",
//                                                                 }}
//                                                             >
//                                                                 <pre style={{ margin: 0, whiteSpace: "pre-wrap" }}>
//                                                                     {msg?.astrologerName}
//                                                                 </pre>
//                                                                 <pre style={{ margin: 0, whiteSpace: "pre-wrap" }}>
//                                                                     {msg.message}
//                                                                 </pre>
//                                                                 <small className="text-muted d-block mt-1">
//                                                                     {msg.timeStamp}
//                                                                 </small>
//                                                             </div>
//                                                         ) : (
//                                                             <div
//                                                                 className="message-right"
//                                                                 style={{
//                                                                     maxWidth: "70%", // Increased max width
//                                                                     background: "#d8fdd1",
//                                                                     textAlign: "right",
//                                                                     marginLeft: "auto",
//                                                                     padding: "0.5rem",
//                                                                     borderRadius: "5px",
//                                                                 }}
//                                                             >
//                                                                 <pre style={{ margin: 0, whiteSpace: "pre-wrap" }}>
//                                                                     {/* {msg.username} */} {/* If you want to display username */}
//                                                                 </pre>
//                                                                 <pre style={{ margin: 0, whiteSpace: "pre-wrap" }}>
//                                                                     {msg.message}
//                                                                 </pre>
//                                                                 <small className="text-muted d-block mt-1">
//                                                                     {msg.timeStamp}
//                                                                 </small>
//                                                             </div>
//                                                         )}
//                                                     </div>
//                                                 ))}
//                                             </div>

//                                             <div
//                                                 className="chat-input"
//                                                 style={{
//                                                     padding: "1rem 0.5rem",
//                                                     backgroundColor: "#fff",
//                                                     display: "flex",
//                                                     alignItems: "center",
//                                                     flexWrap: 'wrap'
//                                                 }}
//                                             >
//                                                 <input
//                                                     type="text"
//                                                     className="form-control"
//                                                     style={{
//                                                         marginRight: "1rem",
//                                                         borderRadius: "2.5rem",
//                                                         padding: "0.5rem 1rem",
//                                                         width: '100%'
//                                                     }}
//                                                     placeholder="Type your message here..."
//                                                     value={input}
//                                                     onChange={(e) => setInput(e.target.value)}
//                                                     onKeyDown={(e) => {
//                                                         if (e.key === "Enter") {
//                                                             handleSendMessage();
//                                                         }
//                                                     }}
//                                                 />
//                                                 <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
//                                                     <button
//                                                         onClick={() => {
//                                                             handleSendMessage();
//                                                         }}
//                                                         style={{
//                                                             fontSize: "12px",
//                                                             backgroundColor: "#ff6f00",
//                                                             color: "#fff",
//                                                             padding: "0.5rem 1rem",
//                                                             border: "none",
//                                                             borderRadius: "5px",
//                                                             marginTop: '15px',
//                                                             justifyContent: 'center'
//                                                         }}
//                                                     >
//                                                         Send
//                                                     </button>
//                                                 </div>
//                                             </div>

//                                             <div
//                                                 className="call-info"
//                                                 style={{
//                                                     padding: "0.5rem",
//                                                     backgroundColor: "#28a745",
//                                                     color: "#fff",
//                                                     display: "flex",
//                                                     alignItems: "center",
//                                                     justifyContent: "center",
//                                                     gap: "0.5rem",
//                                                 }}
//                                             >
//                                                 <span style={{ textAlign: "center" }}>
//                                                     Remaining Time: {Math.floor(timer / 60)}:
//                                                     {String(timer % 60).padStart(2, "0")}
//                                                 </span>
//                                                 <button
//                                                     className="end-call"
//                                                     style={{
//                                                         padding: "0.5rem 1rem",
//                                                         border: "none",
//                                                         borderRadius: "5px",
//                                                     }}
//                                                     onClick={() => { /* Add end call logic here */ }}
//                                                 >
//                                                     End Call
//                                                 </button>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </>
//                     )}
//                 </div>
//             </div>
//         </main>
//     )
// }

// export default Chat
